<div class="l-footer__inner u-px20">
    <div class="l-container">
        <div class="l-footer__logo u-align-center">
            <a href="https://www.arima-onsen.com">
                <img
                    src="https://www.arima-onsen.com/wp/wp-content/themes/arimaonsen/assets/images/logo_white.png"
                    alt="有馬温泉"
                />
            </a>
        </div>
        <nav class="l-footer__nav u-lg-no">
            <ul class="l-footer__list">
                <li class="l-footer__item">
                    <div class="l-footer__parent">
                        <a
                            href="https://www.arima-onsen.com"
                            class="l-footer__link">HOME</a
                        >
                    </div>
                    <ul class="l-footer__childList">
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com"
                                class="l-footer__childLink">ご予約・ご購入</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com"
                                class="l-footer__childLink">有馬芸妓ご予約</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/question"
                                class="l-footer__childLink">よくあるご質問</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/privacypolicy"
                                class="l-footer__childLink"
                                >プライバシーポリシー</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/external_link"
                                class="l-footer__childLink">外部リンク</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/contact"
                                class="l-footer__childLink">お問い合わせ</a
                            >
                        </li>
                    </ul>
                </li>
                <li class="l-footer__item">
                    <div class="l-footer__parent">
                        <a
                            href="https://www.arima-onsen.com/info"
                            class="l-footer__link">お知らせ</a
                        >
                    </div>
                    <ul class="l-footer__childList">
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/info"
                                class="l-footer__childLink">お知らせ</a
                            >
                        </li>
                    </ul>
                </li>
                <li class="l-footer__item">
                    <div class="l-footer__parent">
                        <a
                            href="https://www.arima-onsen.com/about"
                            class="l-footer__link">有馬温泉について</a
                        >
                    </div>
                    <ul class="l-footer__childList">
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/about/history"
                                class="l-footer__childLink">有馬の歴史</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/about/spring_quality"
                                class="l-footer__childLink">泉質</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/about/geiko"
                                class="l-footer__childLink">有馬の芸妓さん</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/about/folk_craft"
                                class="l-footer__childLink">お土産・民芸品</a
                            >
                        </li>
                    </ul>
                </li>
                <li class="l-footer__item">
                    <div class="l-footer__parent">
                        <a
                            href="https://www.arima-onsen.com/pickup"
                            class="l-footer__link">見どころ情報</a
                        >
                    </div>
                    <ul class="l-footer__childList">
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/pickup_category/search"
                                class="l-footer__childLink">宿を探す</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/pickup_category/taste"
                                class="l-footer__childLink">味わう</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/pickup_category/experience"
                                class="l-footer__childLink">体験する</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/pickup_category/buy"
                                class="l-footer__childLink">買う</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/pickup_category/one_day_hot_spring"
                                class="l-footer__childLink">日帰り温泉</a
                            >
                        </li>
                    </ul>
                </li>
                <li class="l-footer__item">
                    <div class="l-footer__parent">
                        <a
                            href="https://www.arima-onsen.com/neighborhood"
                            class="l-footer__link">周辺観光情報</a
                        >
                    </div>
                    <ul class="l-footer__childList">
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/neighborhood_category/hyogo"
                                class="l-footer__childLink">神戸・六甲・姫路</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/neighborhood_category/osaka"
                                class="l-footer__childLink">大阪</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/neighborhood_category/kyoto"
                                class="l-footer__childLink">京都</a
                            >
                        </li>
                    </ul>
                </li>
                <li class="l-footer__item">
                    <div class="l-footer__parent">
                        <a
                            href="https://www.arima-onsen.com/access"
                            class="l-footer__link">交通アクセス</a
                        >
                    </div>
                    <ul class="l-footer__childList">
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/access/tokyo"
                                class="l-footer__childLink"
                                >東京からお越しの方</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/access/osaka"
                                class="l-footer__childLink"
                                >大阪からお越しの方</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/access/others"
                                class="l-footer__childLink"
                                >その他地域からお越しの方</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/access/kyoto"
                                class="l-footer__childLink"
                                >京都からお越しの方</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/access/hyogo"
                                class="l-footer__childLink"
                                >兵庫からお越しの方</a
                            >
                        </li>
                        <li class="l-footer__childItem">
                            <a
                                href="https://www.arima-onsen.com/access/parking"
                                class="l-footer__childLink">駐車場情報</a
                            >
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
        <div class="l-footer__info u-lg-mt10">
            <!-- <div class="l-footer__social">
<div class="socialWrap u-mx-auto">
<div class="socialIcon socialIcon--instagram">
<a href="https://www.arima-onsen.com">
  <img src="https://www.arima-onsen.com/wp/wp-content/themes/arimaonsen/assets/images/instagram.png" alt="Instagram">
</a>
</div>
<div class="socialIcon socialIcon--twitter">
<a href="https://www.arima-onsen.com">
  <img src="https://www.arima-onsen.com/wp/wp-content/themes/arimaonsen/assets/images/twitter.png" alt="Twitter">
</a>
</div>
<div class="socialIcon socialIcon--facebook">
<a href="https://www.arima-onsen.com">
  <img src="https://www.arima-onsen.com/wp/wp-content/themes/arimaonsen/assets/images/facebook.png" alt="Facebook">
</a>
</div>
</div>
</div> -->
            <div class="l-footer__copy u-align-center">
                Copyright© Arima Hot Springs Tourism Association All rights
                reserved.
            </div>
        </div>
    </div>
</div>
<div id="return-top" class="l-footer__returnTop">
    <span />
</div>
